export default __webpack_public_path__ + "static/media/BCA5.5a1aa9d6.jpg";